import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import WidgetEntry from "./WidgetEntry";
import ConfirmReservation from "./pages/ConfirmReservation";
import CancelReservation from "./pages/CancelReservation";
import ReservationManage from "./pages/ReservationManage";
import AppointmentManage from "./pages/AppointmentManage";
import Preferences from "./pages/Preferences";
import Unsubscribe from "./pages/Unsubscribe";
import { LanguageProvider } from "./i18n";
import "./index.css";

// `LanguageProvider` envuelve TODO el árbol de rutas (más simple y sin
// riesgo: es solo un contexto React inerte). Únicamente lo consumen
// `WidgetEntry`→`App` (mesas), `ReservationManage` y `ConfirmReservation`;
// `AppointmentManage`/`Preferences`/`Unsubscribe` no importan `useT()` ni
// `useLanguage()`, así que quedan exactamente igual que antes (fijas en
// español), tal como exige el encargo de internacionalización.
ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <LanguageProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/:slug" element={<WidgetEntry />} />
          <Route path="/r/:token" element={<ReservationManage />} />
          <Route path="/a/:code" element={<AppointmentManage />} />
          <Route
            path="/reserva/:code/confirmar"
            element={<ConfirmReservation />}
          />
          <Route path="/reserva/:code/cancelar" element={<CancelReservation />} />
          <Route path="/preferencias/:token" element={<Preferences />} />
          <Route path="/baja/:token" element={<Unsubscribe />} />
          <Route path="/" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </LanguageProvider>
  </React.StrictMode>,
);

function NotFound() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100">
      <div className="text-center">
        <h1 className="text-4xl font-bold text-gray-800 mb-4">
          ReservaManager
        </h1>
        <p className="text-gray-600">
          Para hacer una reserva, accede a la URL de tu restaurante
        </p>
      </div>
    </div>
  );
}
